import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelAIInferenceStreamVariables = Types.Exact<{
  input: Types.CancelAIInferenceStreamInput;
}>;

export type CancelAIInferenceStream = {
  cancelAIInferenceStream: Pick<
    Types.AIInferenceStream,
    'streamId' | 'cancelled' | 'cancelledAt' | 'finished' | 'error'
  >;
};

export const CancelAIInferenceStreamDocument = gql`
  mutation CancelAIInferenceStream($input: CancelAIInferenceStreamInput!) {
    cancelAIInferenceStream(input: $input) {
      streamId
      cancelled
      cancelledAt
      finished
      error
    }
  }
`;
export type CancelAIInferenceStreamMutationFn = Apollo.MutationFunction<
  CancelAIInferenceStream,
  CancelAIInferenceStreamVariables
>;

/**
 * __useCancelAIInferenceStream__
 *
 * To run a mutation, you first call `useCancelAIInferenceStream` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAIInferenceStream` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAiInferenceStream, { data, loading, error }] = useCancelAIInferenceStream({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAIInferenceStream(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAIInferenceStream,
    CancelAIInferenceStreamVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelAIInferenceStream, CancelAIInferenceStreamVariables>(
    CancelAIInferenceStreamDocument,
    options,
  );
}
export type CancelAIInferenceStreamHookResult = ReturnType<typeof useCancelAIInferenceStream>;
export type CancelAIInferenceStreamMutationResult = Apollo.MutationResult<CancelAIInferenceStream>;
export type CancelAIInferenceStreamMutationOptions = Apollo.BaseMutationOptions<
  CancelAIInferenceStream,
  CancelAIInferenceStreamVariables
>;
export function mockCancelAIInferenceStream({
  data,
  variables,
  errors,
}: {
  data: CancelAIInferenceStream;
  variables?: CancelAIInferenceStreamVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: CancelAIInferenceStreamDocument, variables },
    result: { data, errors },
  };
}
